export default {"src":"/_next/static/media/facebook.ed17fb86.svg","height":40,"width":40};